import { gql } from "@apollo/client";

export const UPDATE_TICKET_MUTATION = gql`
  mutation UpdateTicket($input: UpdateTicketInput!) {
    updateTicket(input: $input) {
      category
      description
      id
      priority
      status
      title
    }
  }
`;

export const CREATE_TICKET_MUTATION = gql`
  mutation CreateTicket($input: CreateTicketInput!) {
    createTicket(input: $input) {
      category
      description
      id
      priority
      status
      title
    }
  }
`;

export const CREATE_TICKET_COMMENT_MUTATION = gql`
  mutation CreateTicketComment($input: CreateTicketCommentInput!) {
    createTicketComment(input: $input) {
      id
      ticket_id
      user_id
      user_schema
      user_name
      user_email
      comment
      created_at
      updated_at
      deleted_at
    }
  }
`;

export const UPDATE_TICKET_COMMENT_MUTATION = gql`
  mutation UpdateTicketComment($input: UpdateTicketCommentInput!) {
    updateTicketComment(input: $input) {
      id
      ticket_id
      user_id
      user_schema
      user_name
      user_email
      comment
      created_at
      updated_at
      deleted_at
    }
  }
`;

export const DELETE_TICKET_COMMENT_MUTATION = gql`
  mutation DeleteTicketComment($input: DeleteTicketCommentInput!) {
    deleteTicketComment(input: $input) {
      success
      message
    }
  }
`;
